import { Combobox, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

export default function SearchableSelect({
  options,
  value,
  onChange,
  placeholder = "",
  errors,
  displayKey = "name",
  searchKeys = ["name", "code"],
}) {
  const [query, setQuery] = useState("");

  const filtered =
    query === ""
      ? options
      : options.filter((opt) =>
          searchKeys.some((k) =>
            (opt[k] ?? "")
              .toString()
              .toLowerCase()
              .includes(query.toLowerCase())
          )
        );

  return (
    <Combobox value={value} onChange={onChange} nullable>
      <div className="relative">
        <div
          className={`relative w-full overflow-hidden rounded-md bg-sky-blue ${
            errors
              ? "ring-2 ring-red-500"
              : "focus-within:ring-2 focus-within:ring-blue"
          }`}
        >
          <Combobox.Input
            className="block w-full border-0 bg-sky-blue py-2 pl-3.5 pr-10 text-black placeholder:text-blue focus:outline-none focus:ring-0 sm:text-sm sm:leading-6 font-lexend"
            displayValue={(opt) => opt?.[displayKey] ?? ""}
            placeholder={placeholder}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon
              className="h-5 w-5 text-blue"
              aria-hidden="true"
            />
          </Combobox.Button>
        </div>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          afterLeave={() => setQuery("")}
        >
          <Combobox.Options className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-blue/20 focus:outline-none font-lexend">
            {filtered.length === 0 && query !== "" ? (
              <div className="relative cursor-default select-none px-4 py-2 text-grey">
                No results.
              </div>
            ) : (
              filtered.map((opt) => (
                <Combobox.Option
                  key={opt.code}
                  value={opt}
                  className={({ active }) =>
                    `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                      active ? "bg-sky-blue text-blue" : "text-black"
                    }`
                  }
                >
                  {({ selected, active }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? "font-semibold" : "font-normal"
                        }`}
                      >
                        {opt[displayKey]}
                        {displayKey !== "code" && (
                          <span className="ml-2 text-xs text-grey">
                            {opt.code}
                          </span>
                        )}
                        {displayKey === "code" && opt.name && (
                          <span className="ml-2 text-xs text-grey">
                            {opt.name}
                          </span>
                        )}
                      </span>
                      {selected && (
                        <span
                          className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                            active ? "text-blue" : "text-blue"
                          }`}
                        >
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      )}
                    </>
                  )}
                </Combobox.Option>
              ))
            )}
          </Combobox.Options>
        </Transition>
      </div>
    </Combobox>
  );
}
